export default "__VITE_ASSET__D56e8uHE__"